// extracted by mini-css-extract-plugin
export default {"data":"data_data__pPHgH","title":"data_title__CoFW8","passDiv":"data_passDiv__dax1N"};